import { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import styled from 'styled-components'
import Button from '../../Button/Button'
import PlanningCard from './PlanningCard/PlanningCard'
import RecommendationModal from '../../RecommendationModal/RecommendationModal'

const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 26px;
  background-color: var(--color-bg-sidebar);
  border-radius: 4px;
  border: 2px solid var(--color-bg-sidebar);
  width: 250px;
  min-height: 322px;
  text-align: left;
  position: relative;

  &::before {
    content: '';
    display: block;
    margin-left: -2px;
    background-color: var(--color-primary);
    overflow: hidden;
    border-radius: 4px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    width: 4px;
    height: 45px;
    position: absolute;
    left: 0;
  }

  @media only screen and (max-width: 920px) {
    min-height: 280px;
  }
`

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-primary);
  width: 40px;
  height: 40px;
  border-radius: 50%;

  svg {
    height: 20px;
    fill: var(--color-bg-main);
  }
`

const Title = styled.h1`
  font-weight: 900;
  margin-left: 16px;
  font-size: 14px;
  flex: 1;
  line-height: 1.1;
  color: var(--color-text-primary);
  padding-right: 8px;
`

const Description = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 21px;
  margin-top: 20px;
  color: var(--color-text-secondary);
  font-size: 14px;
  font-weight: 500;
`

const Estimation = styled.p`
  margin-bottom: 8px;
  background-color: rgba(151, 202, 111, 0.3);
  color: var(--color-text-primary);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  align-items: center;
  margin-left: -27px;
  padding-left: 27px;
  padding-right: 10px;
  font-weight: bold;
  font-size: 12px;
  line-height: 1;
  height: 20px;

  @media only screen and (max-width: 920px) {
    margin-bottom: 16px;
  }
`

const Paragraph = styled.p`
  margin-bottom: 8px;

  @media only screen and (max-width: 920px) {
    margin-bottom: 16px;
  }
`

const StatusBadge = styled.span`
  font-size: 10px;
  font-weight: 900;
  background-color: #f3b349;
  color: var(--color-bg-main);
  padding: 3px 10px;
  border-radius: 12px;
  text-transform: uppercase;
  margin-bottom: 8px;
`

const HighPriorityIcon = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  background-color: #e53935;
  border-radius: 50%;
  border: 2px solid var(--color-bg-sidebar);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px rgba(229, 57, 53, 0.6);
  font-size: 18px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
  user-select: none;
  letter-spacing: -1px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
`

const ButtonGroup = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
`

const GeneralCard = ({
  id,
  title,
  description,
  Icon,
  status,
  recStatus,
  estimation,
  activeCard,
  setActiveCard,
  awsPillar,
  shortDescription,
  highPriority,
}) => {
  const history = useHistory()
  const { state } = useLocation()
  const [isOpen, setOpen] = useState(false)
  const toggle = () => {
    setOpen(open => !open)
    history.replace()
  }

  useEffect(() => {
    if (state?.rec?.id !== id) return
    setOpen(true)
    // eslint-disable-next-line
  }, [state?.rec?.id])

  return (
    <>
      {activeCard === id ? (
        <PlanningCard
          id={id}
          setActiveCard={setActiveCard}
          title={title}
          description={description}
          shortDescription={shortDescription}
          status={status}
          estimation={estimation}
          awsPillar={awsPillar}
          Icon={Icon}
        />
      ) : (
        <Card className="rec-card">
          {highPriority && (
            <HighPriorityIcon title="High Priority">!</HighPriorityIcon>
          )}
          <Row>
            <IconContainer>
              <Icon />
            </IconContainer>
            <Title>{title}</Title>
          </Row>
          <Description>
            {estimation && <Estimation>Estimated {estimation} hours</Estimation>}
            <Paragraph dangerouslySetInnerHTML={{ __html: shortDescription }} />
            {status && <StatusBadge>{status}</StatusBadge>}
          </Description>
          <ButtonGroup>
            <Button
              className="rec-plan-btn"
              onClick={() => setActiveCard(id)}
              isLarge
            >
              Plan this with Caylent
            </Button>
            <Button
              className="rec-view-details-btn"
              isTertiary
              onClick={toggle}
              style={{ marginTop: '12px' }}
            >
              View details
            </Button>
          </ButtonGroup>
        </Card>
      )}
      {isOpen && (
        <RecommendationModal
          isOpen={isOpen}
          toggle={toggle}
          id={id}
          title={title}
          estimation={estimation}
          shortDescription={shortDescription}
          awsPillar={awsPillar}
          description={description}
          status={status}
          recStatus={recStatus}
          Icon={Icon}
        />
      )}
    </>
  )
}

export default GeneralCard
